/* DACKO testimonials — horizontal scroller prev/next nav. Externalized from the
   section's inline <script>; decoupled from section.id via data-testimonials-root;
   re-inits on shopify:section:load for the Theme Editor. */
(() => {
  function initTestimonials(root) {
    if (root.dataset.testimonialsInit) return; // guard against double-binding
    const viewport = root.querySelector('[data-testimonials-viewport]');
    const navButtons = Array.from(root.querySelectorAll('[data-testimonials-nav] .dacko-testimonials__nav-button'));
    const cards = viewport ? Array.from(viewport.querySelectorAll('.dacko-testimonial-card')) : [];
    if (!viewport || navButtons.length === 0 || cards.length === 0) return;
    root.dataset.testimonialsInit = '1';

    const updateNavState = () => {
      const isAtStart = viewport.scrollLeft <= 10;
      const isAtEnd = viewport.scrollLeft + viewport.offsetWidth >= viewport.scrollWidth - 10;
      [isAtStart, isAtEnd].forEach((atLimit, i) => {
        const btn = navButtons[i];
        // A disabled button drops focus, so hand it to the arrow that can still move.
        if (atLimit && document.activeElement === btn && !navButtons[1 - i].disabled) navButtons[1 - i].focus();
        btn.classList.toggle('is-active', !atLimit);
        btn.disabled = atLimit;
      });
    };

    const handleNav = (direction) => {
      // Card width and gap are read from computed styles so the scroll step
      // stays correct across breakpoints
      const track = viewport.querySelector('.dacko-testimonials__track');
      const style = window.getComputedStyle(track);
      const gap = parseInt(style.columnGap || style.gap) || 0;
      const scrollAmount = cards[0].offsetWidth + gap;
      viewport.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    };

    navButtons.forEach((btn) => {
      btn.addEventListener('click', () => handleNav(btn.dataset.nav));
    });

    viewport.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState, { passive: true });

    // Deferred a frame so layout is painted before the offset math runs
    requestAnimationFrame(updateNavState);
  }

  const initAll = (scope) =>
    (scope || document).querySelectorAll('[data-testimonials-root]').forEach(initTestimonials);

  initAll(); // `defer` guarantees the DOM is parsed
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
